module.exports = __webpack_public_path__ + "static/img/logo-szfn.37d068d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-szfn.png
// module id = 8Mv1
// module chunks = 311